import { Venue, DayOfWeek } from '../../../shared/models';
import { getAvailableTimeSlots } from './util';

interface TimeRange {
    start: Date;
    end: Date;
}

export function getVenueOpenHours(venue: Venue, startDay: Date, endDay: Date): TimeRange[] {
    const timeRanges = getAvailableTimeSlots(startDay, endDay, venue, {}, {});

    // Convert TimeRange format to match expected output
    return timeRanges.map(range => ({
        start: range.startTime,
        end: range.endTime
    }));
}
